<template>
    <generic-element-tile-container
        :id="template.first_revision_id"
        :small="small"
        :colClass="elementClass"
        :cardClass="['template-card']"
        entityName="template-card"
    >
        <div class="element-data"
             :data-type="template.is_placeholder ? 'templateplaceholder' : 'template'"
             :data-template-id="template.first_revision_id"
             :data-template-id-last="template.last_revision_id"
             :data-preview-name="template.last_preview"
             :data-display-name="template.name"
             :data-resolution="template.parameters.resolution"
             :data-duration="template.parameters.duration"
             :data-valid-from="template.parameters['valid-from']"
             :data-valid-to="template.parameters['valid-to']"
        />

        <generic-element-tile
            :id="`template-info-${template.first_revision_id}`"
            :title="template.name"
            :img="template"
            :src="template.last_preview"
            :height="'150px'"
            :addMode="template.is_placeholder"
            :noIcon="template.is_placeholder"
            @click="showTemplate"
        />

        <v-card-actions :id="'template-actions-' + template.last_preview" v-if="actionsAvailable">
            <v-btn icon v-if="deletePrivilege === '1' || editPrivilege === '1'" @click="selectTemplate()" :color="selected ? 'primary' : ''">
                <v-icon>{{ selected ? 'fa-regular fa-square-check' : 'fa-regular fa-square' }}</v-icon>
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn icon v-if="editPrivilege === '1'" @click="editTemplate()" :color="selected ? 'primary' : ''">
                <v-icon>fa-regular fa-pencil</v-icon>
            </v-btn>

            <v-btn icon v-if="deletePrivilege === '1'" @click="deleteTemplates()" :color="selected ? 'primary' : ''">
                <v-icon>fa-regular fa-trash</v-icon>
            </v-btn>
        </v-card-actions>
        <v-tooltip-wrapper
            :activator="actionsAvailable ? '#template-actions-' + template.first_revision_id : '#template-info-' + template.first_revision_id"
            v-if="template.is_placeholder !== true">
            <div v-html="tooltipHtml"/>
        </v-tooltip-wrapper>
    </generic-element-tile-container>
</template>

<script>
    import VTooltipWrapper from '../../common/v-tooltip-wrapper.vue'
    import GenericElementTile from "../common/genericElementTile.vue";
    import GenericElementTileContainer from "../common/genericElementTileContainer.vue";

    export default {
        components: {
            GenericElementTileContainer,
            GenericElementTile,
            VTooltipWrapper,
        },
        props: [
            'template',
            'small',
            'mode',
            'viewPrivilege',
            'editPrivilege',
            'deletePrivilege',
            'elementClass',
            'dragDrop'
        ],
        data: function () {
            return {
                t_added: Lang.langGet("Added"),
                t_modified: Lang.langGet("Modified"),
                t_edit: Lang.langGet("Edit"),
                t_delete: Lang.langGet("Delete"),
                t_validity: Lang.langGet("Validity"),
                t_file_name: Lang.langGet("Filename"),
                activeProject: Laravel.activeProject,
                selected: false,
            }
        },
        computed: {
            actionsAvailable: function () {
                return this.deletePrivilege === '1' || this.editPrivilege === '1';
            },
            tooltipHtml() {
                let data = this.template.name + '<br/>';
                data = data + this.t_validity + ': ' +  this.template.parameters['validity-text'] + '<br/>' + this.t_added + ': ' + this.template.created_at + '<br/>' + this.t_modified + ': ' + this.template.updated_at;
                return data;
            }
        },
        methods: {
            editTemplate: function () {
                EaseEventBus.fire('editTemplate', this.template);
            },
            deleteTemplate: function () {
                EaseEventBus.fire('deleteTemplate', this.template);
            },
            showTemplate: function () {
                if (this.template.is_placeholder) {
                    EaseEventBus.fire('newContent', 'templateplaceholder');
                } else {
                    const media = {...this.template, mime_type: 'image/jpg', display_name: this.template.name};
                    EaseEventBus.fire('showMedia', media);
                }
            },
            selectTemplate: function () {
                this.selected = !this.selected;
                EaseEventBus.fire('selectTemplate');
            }

        },
        mounted() {
            EaseEventBus.listen('updateTemplatelist', () => {
                this.selected = false;
            });
        }
    }
</script>
